"use client";
import React, { useEffect } from 'react';
import scrollimg1 from "../../assets/images/moving/IMG-20241030-WA0017.jpg";
import scrollimg2 from "../../assets/images/moving/IMG-20241030-WA0018.jpg";
import scrollimg3 from "../../assets/images/moving/IMG-20241030-WA0019.jpg";
import scrollimg4 from "../../assets/images/moving/IMG-20241030-WA0020.jpg";
import scrollimg5 from "../../assets/images/moving/IMG-20241030-WA0021.jpg";
import scrollimg6 from "../../assets/images/moving/IMG-20241030-WA0022.jpg";
import scrollimg7 from "../../assets/images/moving/IMG-20241030-WA0023.jpg";
import scrollimg8 from "../../assets/images/moving/IMG-20241030-WA0023 (1).jpg";

const scrollIcons = [
  {
    img: scrollimg1,
    text: "Illustrator",
  },
  {
    img: scrollimg2,
    text: "Laravel",
  },
  {
    img: scrollimg3,
    text: "Mongodb",
  },
  {
    img: scrollimg4,
    text: "MySql",
  },
  {
    img: scrollimg5,
    text: "MySql",
  },
  {
    img: scrollimg6,
    text: "Illustrator",
  },
  {
    img: scrollimg7,
    text: "Laravel",
  },
  {
    img: scrollimg3,
    text: "Mongodb",
  },
  {
    img: scrollimg4,
    text: "MySql",
  },
  {
    img: scrollimg5,
    text: "MySql",
  },
];

const Running = () => {
  useEffect(() => {
    const scrollers = document.querySelectorAll(".scroller");

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }

    function addAnimation() {
      scrollers.forEach((scroller) => {
        scroller.setAttribute("data-animated", "true");

        const scrollerInner = scroller.querySelector(".scroller__inner");
        if (scrollerInner) {
          const scrollerContent = Array.from(scrollerInner.children);

          scrollerContent.forEach((item) => {
            const duplicatedItem = item.cloneNode(true);
            duplicatedItem.setAttribute("aria-hidden", "true");
            scrollerInner.appendChild(duplicatedItem);
          });
        }
      });
    }
  }, []);

  return (
    <div className='p-3'>
        <div className="text-center my-5">
          <div className="relative inline-block mx-auto my-2">
           
             <h1 className=" font-bold text-2xl md:text-3xl text-center uppercase">Our Authorities</h1>
           
          </div>
          <p className=" text-orange lg:text-2xl text-xl ">
          Complete Engineering Approval solutions from all Authorities in Dubai
          </p>
        </div>
        <div className="lg:py-4 py-2">
          <div className="scroller" data-direction="right" data-speed="slow">
            <div className="scroller__inner tag-list">
              {scrollIcons.map((image, index) => (
                <div className="your-class " key={index}>
                  <img src={image.img} className='w-full h-full object-contain'/>
                  {/* <p className="pt-2 text-center font-outfit">{image.text}</p> */}
                </div>
              ))}
            </div>
          </div>
          {/* <div className="scroller" data-direction="left" data-speed="slow">
            <div className="scroller__inner tag-list">
              {scrollIcons.map((image, index) => (
                <div className="" key={index}>
                  <img src={image.img} className='w-full h-full'/>
                  <p className="pt-2 text-center font-outfit">
                    {image.text}
                  </p>
                </div>
              ))}
            </div> */}
          {/* </div> */}
        </div>
      </div>
  
  );
};

export default Running;
